var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{on:{"click":_vm.clicked}},[_c('el-checkbox',{ref:"checkbox",staticClass:"jcheckbox",attrs:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event)}},model:{value:(_vm.checkedModel),callback:function ($$v) {_vm.checkedModel=$$v},expression:"checkedModel"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }